import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Ad from "@components/Advertisement/Ad";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import Card from "@particles/card/Card";
import Listing from "@particles/listing/Listing";
import { cn } from "@util/helpers";

type MoreStoriesProps = {
  /** This is the classname of the component. */
  className?: string;
  /** List of articles to be displayed. */
  cardProps: ComponentProps<typeof Card>[];
  /** The urlPath of the keyword page. */
  urlPath: string;
};

/** The more stories component of BT SG60 page.
 * https://www.figma.com/design/50gwyNfDsv70dHaddmTd7k/BT-SG60--WEB---APP-?node-id=164-79153&m=dev
 */
const MoreStories = ({
  className,
  cardProps,
  urlPath,
}: MoreStoriesProps): React.ReactElement => {
  if (cardProps.length === 0) return <></>;

  return (
    <div data-testid="more-stories-component" className={className}>
      <Row>
        <Column rootClassName={cn("w-full mb-8 lg:w-2/3")}>
          <BlockTitle
            text="MORE STORIES"
            rootClassName="mb-4 border-t border-gray-850 pt-3"
          />

          <div className="grid gap-8">
            <Listing
              cardProps={cardProps}
              pageType={"keyword"}
              size={10}
              urlPath={urlPath}
            />
          </div>
        </Column>

        <Column rootClassName={cn("w-full mb-8 lg:w-1/3")}>
          <Ad
            adType="imu2"
            className="flex flex-col items-center justify-center lg:!sticky lg:top-18"
          />
        </Column>
      </Row>
    </div>
  );
};

export default MoreStories;
